import React from "react";
import { Slide } from "react-reveal";
import w1 from "../../assets/images/content/h7.jpeg";
import w2 from "../../assets/images/content/jm2.jpg";
import w3 from "../../assets/images/content/jm7.jpg";
import HighlightCard from "../reusables/HighlightCard";

const OurWorks = () => {
  return (
    <section
      className="section projects section-spacing-100 pale-blue-bg"
      id="recent"
    >
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="width-600 margin-auto center">
              <p className="section-name boldTitle light-blue">
                JMSTONE LOGISTICS LIMITED
              </p>
              <Slide top>
                <div className="section-head">
                  <h2 className="section-title dark">Our recent projects</h2>
                </div>
              </Slide>
            </div>
            <div className="section-body section-spacing-20 width-600 margin-auto">
              <div class="card-container">
                <div class="recent-project-card">
                  <div className="project-timeline">
                    <div className="circle in-progress"></div>
                    <div className="line"></div>
                  </div>
                  <div class="card-header">
                    <span>
                      Client:
                      <strong> EPSILON UGANDA</strong>
                    </span>
                    <span class="status in-progress">On going</span>
                  </div>
                  <div>
                    <span>Work Description:</span>
                    <p className="bold">
                      Pipe works - Butt fusion and HDPE Liner Installation for
                      Dam IB at EnviroServ Waste Management Facility Nyamasoga
                    </p>
                  </div>
                </div>
                <div class="recent-project-card">
                  <div className="project-timeline">
                    <div className="circle in-progress"></div>
                    <div className="line"></div>
                  </div>
                  <div class="card-header">
                    <span>
                      Client:
                      <strong> EnviroServ Uganda</strong>
                    </span>
                    <span class="status in-progress">On going</span>
                  </div>
                  <div>
                    <span>Work Description:</span>
                    <p className="bold">
                      Installation of an HDPE Liner for a leachate collection
                      tank and associated pipe work at EnviroServ Waste
                      Management Facility Nyamasoga
                    </p>
                  </div>
                </div>

                <div class="recent-project-card">
                  <div className="project-timeline">
                    <div className="circle completed"></div>
                    <div className="line"></div>
                  </div>
                  <div class="card-header">
                    <span>
                      Client:
                      <strong>MOTA-ENGIL Uganda</strong>
                    </span>
                    <span class="status completed">
                      Completed-::-25/02/2025
                    </span>
                  </div>
                  <div>
                    <span>Work Description:</span>
                    <p className="bold">
                      Installing of HDPE liner at CPF 4210 and 4150
                    </p>
                  </div>
                </div>
                <div class="recent-project-card">
                  <div className="project-timeline">
                    <div className="circle completed"></div>
                    <div className="line"></div>
                  </div>
                  <div class="card-header">
                    <span>
                      Client:
                      <strong>MOTA-ENGIL Uganda</strong>
                    </span>
                    <span class="status completed">
                      Completed-::-22/02/2025
                    </span>
                  </div>
                  <div>
                    <span>Work Description:</span>
                    <p className="bold">
                      Installing of HDPE liner at CFT4 JBR09- North
                    </p>
                  </div>
                </div>
                <div class="recent-project-card">
                  <div className="project-timeline">
                    <div className="circle completed"></div>
                    <div className="line"></div>
                  </div>
                  <div class="card-header">
                    <span>
                      Client:
                      <strong>EPSILON UGANDA</strong>
                    </span>
                    <span class="status completed">
                      Completed-::-17/01/2025
                    </span>
                  </div>
                  <div>
                    <span>Work Description:</span>
                    <p className="bold">
                      Geomembrane Liner Installation at 6 Mud Cutting pits at
                      Tangi Camp – Pakwach.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="section-footer buttons-container flex justify-center section-spacing-20 no-padding-bottom">
              <a
                href="/projects"
                className="button sub-cta boldTitle dark uppercase"
              >
                See More &#8594;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurWorks;
